export const normalizeText = (val) => {
  if (!val) return null;

  // handle arrays separately
  if (Array.isArray(val)) {
    const cleaned = val
      .filter(
        (v) => v && typeof v === "string" && v.trim().toLowerCase() !== "none"
      )
      .map((v) => v.trim());

    return cleaned.length ? cleaned.join(", ") : null;
  }

  if (typeof val === "string") {
    const cleaned = val.trim();
    if (cleaned.toLowerCase() === "none") return null;
    return cleaned;
  }

  return val;
};

export function truncateText(text, maxLength = 50) {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 3).trim() + "...";
}

export const sortByDisplayOnCardAndExtractNames = (items = []) => {
  if (!Array.isArray(items)) return [];

  return items
    .slice()
    .sort(
      (a, b) =>
        Number(b.displayOnCard === true) - Number(a.displayOnCard === true)
    )
    .map((item) => item.name)
    .filter(Boolean);
};

export const replaceNullWithPlaceholder = (value, replaceBy) => {
  if (value === null || value === undefined || value === "") {
    return replaceBy ?? "N/A";
  }
  return value;
};
